// Features section content
export const features = {
  headline: 'Enterprise Features for Modern Teams.',
  lead: 'Generate professional presentations at scale with AI intelligence. Connect to your workflows, maintain brand consistency, and deploy anywhere with enterprise-grade security.',

  items: [
    {
      number: '01',
      title: 'Multi-AI Intelligence',
      description: 'Leverage OpenAI, Azure OpenAI, Anthropic Claude, Mistral, or run locally with Ollama. Choose the AI that fits your needs, switch providers on the fly, and always get the best results for your content.'
    },
    {
      number: '02',
      title: 'Workflow Integration',
      description: 'Native N8N integration connects SlideFactory to your existing business processes. Trigger presentations from CRM updates, form submissions, scheduled reports, or any automated workflow in your stack.'
    },
    {
      number: '03',
      title: 'RAG-Powered Context',
      description: 'Upload documents and let our RAG engine with pgvector extract the most relevant content. Create presentations that leverage your organization\'s knowledge base with intelligent semantic search.'
    },
    {
      number: '04',
      title: 'Enterprise Security',
      description: 'JWT authentication, OAuth integration, and API key management built-in. Deploy on Azure, on-premises, or your private cloud with full data sovereignty and audit logging.'
    },
    {
      number: '05',
      title: 'Template System',
      description: 'Jinja2-powered templates give you complete control over output. Match your brand guidelines, enforce corporate standards, and maintain consistency at scale across all generated presentations.'
    },
    {
      number: '06',
      title: 'Flexible Deployment',
      description: 'Multi-cloud ready with Azure-optimized configurations. Run in containers, Kubernetes, or bare metal. Scale from startup to enterprise seamlessly with Docker and infrastructure as code support.'
    }
  ]
}
